import { Observable, Observer } from 'rxjs';

export class BinaryReaderService {
  readAsUrlString(blob: Blob): Observable<string> {
    return new Observable<string>((observer: Observer<string>): void => {
      let fileReader = new FileReader();
      fileReader.onload = (e: ProgressEvent): void => {
        let target: any = e.target;
        if (typeof target.result === 'string') {
          observer.next(target.result);
          observer.complete();
        }
      };
      fileReader.onerror = (e: ProgressEvent): void => {
        observer.error(e);
      };
      fileReader.readAsDataURL(blob);
    });
  }
}
